import { createSlice } from '@reduxjs/toolkit'

import { fetchBillingPolicy } from './actions/fetch_billing_policy'

const policySlice = createSlice({
  name: 'policy',
  initialState: {
    initialized: false,
    error: null
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBillingPolicy.pending, (state) => {
      state.initialized = false
      state.error = null
    })
    builder.addCase(fetchBillingPolicy.fulfilled, (_, action) => ({
      initialized: true,
      ...action.payload.policy
    }))
    builder.addCase(fetchBillingPolicy.rejected, (state, action) => {
      state.initialized = true
      state.error = action.payload
    })
  }
})

export const { reducer } = policySlice
